<template>
  <figure class="card-cover-image" :style="bgStyle">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
      <filter id="blur">
        <feGaussianBlur stdDeviation="12" />
      </filter>
    </svg>
  </figure>
</template>

<script>
export default {
  name: 'card-cover-image',

  props: [
    'imageUrl',
  ],

  computed: {
    bgStyle() {
      return {
        'background-image': `url(${this.imageUrl})`,
      };
    },
  },
};
</script>

<style lang="scss">
  $card-cover-image-blur: 12px !default;
  $card-cover-image-bg: rgba(0,0,0,.5) !default;

  .card-cover-image {
    position: fixed;

    top: $card-cover-image-blur * -2;
    right: $card-cover-image-blur * -2;
    bottom: $card-cover-image-blur * -2;
    left: $card-cover-image-blur * -2;

    padding: 0;
    margin: 0;

    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;

    filter: blur($card-cover-image-blur);

    &, &:before {
      z-index: -1;
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      display: block;
      content: ' ';

      background: $card-cover-image-bg;
    }
  }
</style>

